import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Radio, DatePicker, message, Select } from 'antd';
import apis from '../../../../apis';
import './index.less';
import moment from 'moment';

const layout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 16,
  },
};

const { RangePicker } = DatePicker;
const { Option } = Select;

function AddPage(props) {
  const { visible, setVisible, towerId, planCode, refresh, setRefresh } = props;
  const [form] = Form.useForm();
  const [value, setValue] = useState(0);
  const [categoryList, setCategoryList] = useState([]);
  const [loadding, setLoadding] = useState(false);

  const onChange = (e) => {
    setValue(e.target.value);
  };

  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    setVisible(false);
    setValue(0);
    form.resetFields();
  };

  const onFormFinish = (values) => {
    if (loadding) return;
    const { name, startTime, relatedId, activityName, activityTime, remark, category, interestPoint } = values;
    const query = {
      planCode: planCode,
      roomId: towerId,
      name: name,
      startTime: new Date(startTime).getTime(),
      relatedId: relatedId,
      gatherActivity:
        value === 1
          ? {
              name: activityName,
              startTime: new Date(activityTime[0]).getTime(),
              endTime: new Date(activityTime[1]).getTime(),
              remark: remark,
              category: categoryList
                .filter((item) => item.categoryName === category)
                .map((item) => item.categoryId)
                .join(''),
              interestPoint: interestPoint,
            }
          : undefined,
    };
    setLoadding(true);
    apis
      .actRoomAddPage(query)
      .then((res) => {
        const { ret, msg } = res;
        if (ret === '0') {
          message.success('新建成功');
          setVisible(false);
          setRefresh(!refresh);
          setValue(0);
          form.resetFields();
        } else {
          message.error(msg);
          form.resetFields();
        }
        setLoadding(false);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const checkNums = {
    validator: (_, value) => {
      return new Promise((resolve, reject) => {
        // 如果是空字符串则跳出
        if (!value) return resolve();
        const reg = new RegExp(/^[0-9]*$/);
        if (!reg.test(value)) return reject(new Error('请输入数字'));
        resolve();
      });
    },
  };

  useEffect(() => {
    apis
      .cateList({ currentPage: 1 })
      .then((res) => {
        const { ret, msg, data } = res;
        if (ret === '0') {
          setCategoryList(data.categorys);
        } else {
          message.error(msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  useEffect(() => {
    if (!planCode) return;
    if (!visible) return;
    apis
      .activityPlanGet({
        planCode: planCode,
      })
      .then((res) => {
        const { ret, msg, data } = res;
        const {
          activityName,
          activityStartTime,
          activityEndTime,
          remark,
          categoryName,
          interestPoint,
        } = data.activityPlan;
        if (ret === '0') {
          form.setFieldsValue({
            activityName: activityName,
            activityTime: [moment(activityStartTime), moment(activityEndTime)],
            remark: remark,
            category: categoryName,
            interestPoint: interestPoint,
          });
        } else {
          message.error(msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  return (
    <Modal
      title={
        <span className="venueDetail__addPage__modal__title">
          新建页面
          <span className="venueDetail__addPage__modal__sub-title">同步完成会场收品活动创建</span>
        </span>
      }
      visible={visible}
      onCancel={handleCancel}
      onOk={handleOk}
    >
      <Form {...layout} form={form} onFinish={onFormFinish}>
        <Form.Item
          label="页面名称: "
          name="name"
          rules={[
            {
              required: true,
              message: '页面名称不能为空',
            },
          ]}
        >
          <Input placeholder="请输入页面名称" />
        </Form.Item>
        <Form.Item
          label="生效时间: "
          name="startTime"
          rules={[
            {
              required: true,
              message: '生效时间不能为空',
            },
          ]}
        >
          <DatePicker />
        </Form.Item>
        <div className="venueDetail__addPage__modal__sub-form-item">请选择收品活动创建方式: </div>
        <Radio.Group onChange={onChange} value={value} style={{ display: 'flex', flexDirection: 'column' }}>
          <Radio value={0} className="venueDetail__addPage__modal__sub-form-item">
            关联已有活动
          </Radio>
          {value === 0 && (
            <Form.Item
              name="relatedId"
              rules={[
                {
                  required: true,
                  message: '提报系统活动编号不能为空',
                },
                checkNums,
              ]}
            >
              <Input placeholder="请输入提报系统活动编号" />
            </Form.Item>
          )}
          <Radio value={1} className="venueDetail__addPage__modal__sub-form-item">
            新建收品活动
          </Radio>
          {value === 1 && (
            <>
              <Form.Item
                label="活动名称"
                name="activityName"
                rules={[
                  {
                    required: true,
                    message: '活动名称不能为空',
                  },
                ]}
              >
                <Input placeholder="请输入活动名称" />
              </Form.Item>
              <Form.Item
                label="活动时间"
                name="activityTime"
                rules={[
                  {
                    required: true,
                    message: '活动时间不能为空',
                  },
                ]}
              >
                <RangePicker />
              </Form.Item>
              <Form.Item
                label="活动介绍"
                name="remark"
                rules={[
                  {
                    required: true,
                    message: '活动介绍不能为空',
                  },
                ]}
              >
                <Input placeholder="请输入活动介绍" />
              </Form.Item>
              <Form.Item
                label="行业分组"
                name="category"
                rules={[
                  {
                    required: true,
                    message: '行业分组不能为空',
                  },
                ]}
              >
                <Select allowClear showSearch>
                  {categoryList &&
                    categoryList.map((item, index) => (
                      <Option value={item.categoryName} key={index}>
                        {item.categoryName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="利益点"
                name="interestPoint"
                // rules={[
                //   {
                //     required: true,
                //     message: '利益点不能为空'
                //   }
                // ]}
              >
                <Input placeholder="请输入利益点" />
              </Form.Item>
            </>
          )}
        </Radio.Group>
      </Form>
    </Modal>
  );
}

export default AddPage;
